import { render, staticRenderFns } from "./ClientProjectsEditDetailsStep1.vue?vue&type=template&id=00908e72&"
import script from "./ClientProjectsEditDetailsStep1.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsEditDetailsStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports